import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import {
	Box,
	Button,
	CircularProgress,
	Grid,
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	TableContainer,
	Paper,
	Menu,
	MenuItem,
} from "@mui/material";
import btcImage from "../../assets/images/btc.png";
import ethImage from "../../assets/images/eth.png";
import usdtethImage from "../../assets/images/usdt-erc20.png";
import usdttronImage from "../../assets/images/usdt-trc20.png";
import usdcethImage from "../../assets/images/usdc-erc20.png";
import trxImage from "../../assets/images/trx.png";
import ltcImage from "../../assets/images/ltc.png";
import xrpImage from "../../assets/images/xrp.png";
import dogeImage from "../../assets/images/doge.png";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { getAgentDashboardBalances } from "../../actions/agent";
import { getDecimalsByCrypto } from "../../utils/cryptoCurrenciesUtils";
import { CryptoCurrencies } from "../../enums/cryptoCurrency";
import { Networks } from "../../enums/networks";
import { useNavigate } from "react-router";
import { makeStyles } from "@mui/styles";

const styleButton = {
	backgroundColor: "#027af2",
	color: "#FFFFFF",
	height: "25px",
	width: "125px",
	textTransform: "capitalize",
	marginLeft: 2,
	"&:hover": {
		color: "#FFFFFF",
		backgroundColor: "#003399",
	},
};

const useStyles = makeStyles({
	odd: {},
	even: {},
});

const styleCellAmount = {
	textAlign: "right",
	paddingLeft: 2,
	paddingTop: 0,
	paddingRight: 2,
	paddingBottom: 0,
	margin: 0,
	minWidth: 250,
};

const styleCellButton = {
	textAlign: "right",
	padding: 0,
	margin: 0,
};

const AgentBalances = ({ token, id, isAuthenticated, setIsAuthenticated }) => {
	const [balances, setBalances] = useState(null);
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const navigate = useNavigate();
	const classes = useStyles();
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const actionWithdrawalButton = (cryptoCurrency, network) => {
		navigate(`/withdrawal/${cryptoCurrency}/${network}`);
	};

	const actionTransferButton = (cryptoCurrency, network) => {
		navigate(`/agenttransfer/${cryptoCurrency}/${network}`);
	};

	const actionDepositButton = (cryptoCurrency, network) => {
		navigate(`/deposit/${cryptoCurrency}/${network}`);
	};

	useEffect(() => {
		getAgentDashboardBalances(token, id, (res) => {
			if (!res.error) {
				setBalances(res.data);
			} else {
				if (res.message.toString().includes("Token Expired")) {
					navigate("/logout");
				}
			}
		});
	}, []);
	if (balances) {
		if (balances.isAdmin) {
			return (
				<>
					<Card variant="outlined" sx={{ width: "100%" }}>
						<CardContent>
							<Typography component="h2" variant="subtitle1" gutterBottom>
								Balances
							</Typography>
							<Stack sx={{ justifyContent: "space-between" }}>
								<Typography variant="caption" sx={{ color: "text.secondary" }}>
									Balances by Crypto Currency
								</Typography>
							</Stack>
							<TableContainer component={Paper}>
								<Table sx={{ width: "97%", overflowX: "auto" }}>
									<TableHead>
										<TableRow>
											<TableCell sx={{ padding: 0, margin: 0 }}></TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle1" gutterBottom>
													Crypto
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle1" gutterBottom>
													Network
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle1" gutterBottom>
													Balance
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle1" gutterBottom>
													Exchange Rate
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle1" gutterBottom>
													$USD
												</Typography>
											</TableCell>
											{/*<TableCell sx={{ padding: 0, margin: 0 }}></TableCell>*/}
											{/*<TableCell sx={{ padding: 0, margin: 0 }}></TableCell>*/}
											{/*<TableCell sx={{ padding: 0, margin: 0 }}></TableCell>*/}
										</TableRow>
									</TableHead>
									<TableBody>
										<TableRow className={classes.odd}>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={btcImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													BTC
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													BITCOIN
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{balances.balances.channelBalanceBTC
														? parseFloat(
																parseFloat(
																	balances.balances.channelBalanceBTC +
																		balances.balances.walletBalanceBTC -
																		balances.balances.pendingsBTC
																)
														  ).toFixed(getDecimalsByCrypto(CryptoCurrencies.BTC))
														: "0.00000000"}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateBTC).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													${" "}
													{!isNaN(balances.balances.pendingsBTC)
														? parseFloat(
																(balances.balances.channelBalanceBTC +
																	balances.balances.walletBalanceBTC -
																	balances.balances.pendingsBTC) *
																	balances.exchangeRate.exchangeRateBTC
														  ).toFixed(4)
														: "0.0000"}
												</Typography>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
										<Button variant="extended" sx={styleButton} onClick={() => processDeposit(CryptoCurrencies.BTC, Networks.BITCOIN)}>
											Deposit
										</Button>
									</TableCell>
										<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton} onClick={() => actionWithdrawalButton(CryptoCurrencies.BTC, Networks.BITCOIN)}>
												Withdraw
											</Button>
										</TableCell>*/}
											{/*<TableCell sx={styleCellButton}>
											<IconButton
												color="primary"
												aria-label="upload picture"
												component="span"
												sx={{ border: 0 }}
												id="btcAdditionals"
												aria-controls={open ? "btcAdditionalMenu" : undefined}
												aria-haspopup="true"
												aria-expanded={open ? "true" : undefined}
												onClick={handleClick}
											>
												<MoreVertIcon />
											</IconButton>
											<Menu
												id="btcAdditionalMenu"
												aria-labelledby="btcAdditionals"
												anchorEl={anchorEl}
												open={open}
												onClose={handleClose}
												anchorOrigin={{
													vertical: "top",
													horizontal: "left",
												}}
												transformOrigin={{
													vertical: "top",
													horizontal: "left",
												}}
											>
												<MenuItem onClick={handleClose}>Transfer</MenuItem>
												<MenuItem onClick={handleClose}>Transactions</MenuItem>
											</Menu>
										</TableCell>*/}
										</TableRow>
										<TableRow>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={ethImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													ETH
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													ETHEREUM
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{balances.balances.balanceAdminETH
														? parseFloat(balances.balances.balanceAdminETH).toFixed(
																getDecimalsByCrypto(CryptoCurrencies.ETH)
														  )
														: "0.000000000000000000"}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateETH).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													${" "}
													{!isNaN(balances.balances.pendingsETH)
														? parseFloat(
																(balances.balances.balanceAdminETH - balances.balances.pendingsETH) *
																	balances.exchangeRate.exchangeRateETH
														  ).toFixed(4)
														: "0.0000"}
												</Typography>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton}>
												Deposit
											</Button>
										</TableCell>
										<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton} onClick={() => actionWithdrawalButton(CryptoCurrencies.ETH, Networks.ETHEREUM)}>
												Withdraw
											</Button>
										</TableCell>*/}
											{/*<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow className={classes.odd}>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={ethImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													ETH
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													BASE
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{balances.balances.balanceAdminETHBASE
														? parseFloat(balances.balances.balanceAdminETHBASE).toFixed(
																getDecimalsByCrypto(CryptoCurrencies.ETH)
														  )
														: "0.000000000000000000"}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateETH).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													${" "}
													{!isNaN(balances.balances.pendingsETHBASE)
														? parseFloat(
																(balances.balances.balanceAdminETHBASE - balances.balances.pendingsETHBASE) *
																	balances.exchangeRate.exchangeRateETH
														  ).toFixed(4)
														: "0.0000"}
												</Typography>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton}>
												Deposit
											</Button>
										</TableCell>
										<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton} onClick={() => actionWithdrawalButton(CryptoCurrencies.ETH, Networks.BASE)}>
												Withdraw
											</Button>
										</TableCell>*/}
											{/*<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={usdtethImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													USDT
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													ETHEREUM
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{balances.balances.balanceAdminUSDT
														? parseFloat(balances.balances.balanceAdminUSDT).toFixed(
																getDecimalsByCrypto(CryptoCurrencies.USDT)
														  )
														: "0.000000"}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateUSDT).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													${" "}
													{!isNaN(balances.balances.pendingsUSDT)
														? parseFloat(
																(balances.balances.balanceAdminUSDT - balances.balances.pendingsUSDT) *
																	balances.exchangeRate.exchangeRateUSDT
														  ).toFixed(4)
														: "0.0000"}
												</Typography>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton}>
												Deposit
											</Button>
										</TableCell>
										<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton} onClick={() => actionWithdrawalButton(CryptoCurrencies.USDT, Networks.ETHEREUM)}>
												Withdraw
											</Button>
										</TableCell>*/}
											{/*<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow className={classes.odd}>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={usdttronImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													USDT
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													TRON
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{balances.balances.balanceAdminUSDTTRON
														? parseFloat(balances.balances.balanceAdminUSDTTRON).toFixed(
																getDecimalsByCrypto(CryptoCurrencies.USDT)
														  )
														: "0.000000"}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateUSDT).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													${" "}
													{!isNaN(balances.balances.pendingsUSDTTRON)
														? parseFloat(
																(balances.balances.balanceAdminUSDTTRON - balances.balances.pendingsUSDTTRON) *
																	balances.exchangeRate.exchangeRateUSDT
														  ).toFixed(4)
														: "0.0000"}
												</Typography>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton}>
												Deposit
											</Button>
										</TableCell>
										<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton} onClick={() => actionWithdrawalButton(CryptoCurrencies.USDT, Networks.TRON)}>
												Withdraw
											</Button>
										</TableCell>*/}
											{/*<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={trxImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													TRX
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													TRON
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{balances.balances.balanceAdminTRX
														? parseFloat(balances.balances.balanceAdminTRX).toFixed(
																getDecimalsByCrypto(CryptoCurrencies.TRX)
														  )
														: "0.000000"}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateTRX).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													${" "}
													{!isNaN(balances.balances.pendingsTRX)
														? parseFloat(
																(balances.balances.balanceAdminTRX - balances.balances.pendingsTRX) *
																	balances.exchangeRate.exchangeRateTRX
														  ).toFixed(4)
														: "0.0000"}
												</Typography>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton}>
												Deposit
											</Button>
										</TableCell>
										<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton} onClick={() => actionWithdrawalButton(CryptoCurrencies.TRX, Networks.TRON)}>
												Withdraw
											</Button>
										</TableCell>*/}
											{/*<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow className={classes.odd}>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={usdcethImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													USDC
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													ETHEREUM
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{balances.balances.balanceAdminUSDC
														? parseFloat(balances.balances.balanceAdminUSDC).toFixed(
																getDecimalsByCrypto(CryptoCurrencies.USDC)
														  )
														: "0.000000"}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateUSDC).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													${" "}
													{!isNaN(balances.balances.pendingsUSDC)
														? parseFloat(
																(balances.balances.balanceAdminUSDC - balances.balances.pendingsUSDC) *
																	balances.exchangeRate.exchangeRateUSDC
														  ).toFixed(4)
														: "0.0000"}
												</Typography>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton}>
												Deposit
											</Button>
										</TableCell>
										<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton} onClick={() => actionWithdrawalButton(CryptoCurrencies.USDC, Networks.ETHEREUM)}>
												Withdraw
											</Button>
										</TableCell>*/}
											{/*<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={usdcethImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													USDC
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													BASE
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{balances.balances.balanceAdminUSDCBASE
														? parseFloat(balances.balances.balanceAdminUSDCBASE).toFixed(
																getDecimalsByCrypto(CryptoCurrencies.USDC)
														  )
														: "0.000000"}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateUSDC).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													${" "}
													{!isNaN(balances.balances.pendingsUSDCBASE)
														? parseFloat(
																(balances.balances.balanceAdminUSDCBASE - balances.balances.pendingsUSDCBASE) *
																	balances.exchangeRate.exchangeRateUSDC
														  ).toFixed(4)
														: "0.0000"}
												</Typography>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton}>
												Deposit
											</Button>
										</TableCell>
										<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton} onClick={() => actionWithdrawalButton(CryptoCurrencies.USDCBTC, Networks.BASE)}>
												Withdraw
											</Button>
										</TableCell>*/}
											{/*<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow className={classes.odd}>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={dogeImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													DOGE
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													DOGECOIN
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{balances.balances.balanceAdminDOGE
														? parseFloat(balances.balances.balanceAdminDOGE).toFixed(
																getDecimalsByCrypto(CryptoCurrencies.DOGE)
														  )
														: "0.000000"}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateDOGE).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													${" "}
													{!isNaN(balances.balances.pendingsDOGE)
														? parseFloat(
																(balances.balances.balanceAdminDOGE - balances.balances.pendingsDOGE) *
																	balances.exchangeRate.exchangeRateDOGE
														  ).toFixed(4)
														: "0.0000"}
												</Typography>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton}>
												Deposit
											</Button>
										</TableCell>
										<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton} onClick={() => actionWithdrawalButton(CryptoCurrencies.DOGE, Networks.DOGECOIN)}>
												Withdraw
											</Button>
										</TableCell>*/}
											{/*<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={xrpImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													XRP
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													RIPPLE
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{balances.balances.balanceAdminXRP
														? parseFloat(balances.balances.balanceAdminXRP).toFixed(
																getDecimalsByCrypto(CryptoCurrencies.XRP)
														  )
														: "0.000000"}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateXRP).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													${" "}
													{!isNaN(balances.balances.pendingsXRP)
														? parseFloat(
																(balances.balances.balanceAdminXRP - balances.balances.pendingsXRP) *
																	balances.exchangeRate.exchangeRateXRP
														  ).toFixed(4)
														: "0.0000"}
												</Typography>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton}>
												Deposit
											</Button>
										</TableCell>
										<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton} onClick={() => actionWithdrawalButton(CryptoCurrencies.XRP, Networks.RIPPLE)}>
												Withdraw
											</Button>
										</TableCell>*/}
											{/*<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow className={classes.odd}>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={ltcImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													LTC
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													LITECOIN
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{balances.balances.balanceAdminLTC
														? parseFloat(balances.balances.balanceAdminLTC).toFixed(
																getDecimalsByCrypto(CryptoCurrencies.LTC)
														  )
														: "0.000000"}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateLTC).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													${" "}
													{!isNaN(balances.balances.pendingsLTC)
														? parseFloat(
																(balances.balances.balanceAdminLTC - balances.balances.pendingsLTC) *
																	balances.exchangeRate.exchangeRateLTC
														  ).toFixed(4)
														: "0.0000"}
												</Typography>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton}>
												Deposit
											</Button>
										</TableCell>
										<TableCell sx={styleCellButton}>
											<Button variant="extended" sx={styleButton} onClick={() => actionWithdrawalButton(CryptoCurrencies.LTC, Networks.LITECOIN)}>
												Withdraw
											</Button>
										</TableCell>*/}
											{/*<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
									</TableBody>
								</Table>
							</TableContainer>
						</CardContent>
					</Card>
				</>
			);
		} else {
			return (
				<>
					<Card variant="outlined" sx={{ width: "100%" }}>
						<CardContent>
							<Typography component="h2" variant="subtitle1" gutterBottom>
								Balances
							</Typography>
							<Stack sx={{ justifyContent: "space-between" }}>
								<Typography variant="caption" sx={{ color: "text.secondary" }}>
									Balances by Crypto Currency
								</Typography>
							</Stack>
							<TableContainer component={Paper}>
								<Table sx={{ width: "97%", overflowX: "auto" }}>
									<TableHead>
										<TableRow>
											<TableCell sx={{ padding: 0, margin: 0 }}></TableCell>
											<TableCell sx={{ padding: 0, margin: 0, minWidth: 100 }}>
												<Typography component="h2" variant="subtitle1" gutterBottom>
													Crypto
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0, minWidth: 100 }}>
												<Typography component="h2" variant="subtitle1" gutterBottom>
													Network
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle1" gutterBottom>
													Balance
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle1" gutterBottom>
													Exchange Rate
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle1" gutterBottom>
													$USD
												</Typography>
											</TableCell>
											<TableCell sx={{ marginLeft: 2 }}></TableCell>
											<TableCell sx={{ marginLeft: 2 }}></TableCell>
											{/*<TableCell sx={{ marginLeft: 2 }}></TableCell>*/}
										</TableRow>
									</TableHead>
									<TableBody>
										<TableRow className={classes.odd}>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={btcImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													BTC
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													BITCOIN
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.balances.balanceBTC).toFixed(getDecimalsByCrypto(CryptoCurrencies.BTC))}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateBTC).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateBTC * balances.balances.balanceBTC).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionDepositButton(CryptoCurrencies.BTC, Networks.BITCOIN)}
												>
													Deposit
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionWithdrawalButton(CryptoCurrencies.BTC, Networks.BITCOIN)}
												>
													Withdraw
												</Button>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionTransferButton(CryptoCurrencies.BTC, Networks.BITCOIN)}
												>
													Transfer
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
											<IconButton
												color="primary"
												aria-label="upload picture"
												component="span"
												sx={{ border: 0 }}
												id="btcAdditionals"
												aria-controls={open ? "btcAdditionalMenu" : undefined}
												aria-haspopup="true"
												aria-expanded={open ? "true" : undefined}
												onClick={handleClick}
											>
												<MoreVertIcon />
											</IconButton>
											<Menu
												id="btcAdditionalMenu"
												aria-labelledby="btcAdditionals"
												anchorEl={anchorEl}
												open={open}
												onClose={handleClose}
												anchorOrigin={{
													vertical: "top",
													horizontal: "left",
												}}
												transformOrigin={{
													vertical: "top",
													horizontal: "left",
												}}
											>
												<MenuItem onClick={handleClose}>Transfer</MenuItem>
												<MenuItem onClick={handleClose}>Transactions</MenuItem>
											</Menu>
										</TableCell>*/}
										</TableRow>
										<TableRow>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={ethImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													ETH
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													ETHEREUM
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.balances.balanceETH).toFixed(getDecimalsByCrypto(CryptoCurrencies.ETH))}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateETH).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateETH * balances.balances.balanceETH).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionDepositButton(CryptoCurrencies.ETH, Networks.ETHEREUM)}
												>
													Deposit
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionWithdrawalButton(CryptoCurrencies.ETH, Networks.ETHEREUM)}
												>
													Withdraw
												</Button>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionTransferButton(CryptoCurrencies.ETH, Networks.ETHEREUM)}
												>
													Transfer
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow className={classes.odd}>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={ethImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													ETH
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													BASE
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.balances.balanceETHBASE).toFixed(getDecimalsByCrypto(CryptoCurrencies.ETH))}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateETH).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateETH * balances.balances.balanceETHBASE).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionDepositButton(CryptoCurrencies.ETH, Networks.BASE)}
												>
													Deposit
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionWithdrawalButton(CryptoCurrencies.ETH, Networks.BASE)}
												>
													Withdraw
												</Button>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionTransferButton(CryptoCurrencies.ETH, Networks.BASE)}
												>
													Transfer
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={usdtethImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													USDT
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													ETHEREUM
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.balances.balanceUSDT).toFixed(getDecimalsByCrypto(CryptoCurrencies.USDT))}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateUSDT).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateUSDT * balances.balances.balanceUSDT).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionDepositButton(CryptoCurrencies.USDT, Networks.ETHEREUM)}
												>
													Deposit
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionWithdrawalButton(CryptoCurrencies.USDT, Networks.ETHEREUM)}
												>
													Withdraw
												</Button>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionTransferButton(CryptoCurrencies.USDT, Networks.ETHEREUM)}
												>
													Transfer
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow className={classes.odd}>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={usdttronImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													USDT
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													TRON
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.balances.balanceUSDTTRON).toFixed(
														getDecimalsByCrypto(CryptoCurrencies.USDT)
													)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateUSDT).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateUSDT * balances.balances.balanceUSDTTRON).toFixed(
														4
													)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionDepositButton(CryptoCurrencies.USDT, Networks.TRON)}
												>
													Deposit
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionWithdrawalButton(CryptoCurrencies.USDT, Networks.TRON)}
												>
													Withdraw
												</Button>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionTransferButton(CryptoCurrencies.USDT, Networks.TRON)}
												>
													Transfer
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={trxImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													TRX
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													TRON
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.balances.balanceTRX).toFixed(getDecimalsByCrypto(CryptoCurrencies.TRX))}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateTRX).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateTRX * balances.balances.balanceTRX).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionDepositButton(CryptoCurrencies.TRX, Networks.TRON)}
												>
													Deposit
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionWithdrawalButton(CryptoCurrencies.TRX, Networks.TRON)}
												>
													Withdraw
												</Button>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionTransferButton(CryptoCurrencies.TRX, Networks.TRON)}
												>
													Transfer
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow className={classes.odd}>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={usdcethImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													USDC
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													ETHEREUM
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.balances.balanceUSDC).toFixed(getDecimalsByCrypto(CryptoCurrencies.USDC))}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateUSDC).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateUSDC * balances.balances.balanceUSDC).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionDepositButton(CryptoCurrencies.USDC, Networks.ETHEREUM)}
												>
													Deposit
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionWithdrawalButton(CryptoCurrencies.USDC, Networks.ETHEREUM)}
												>
													Withdraw
												</Button>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionTransferButton(CryptoCurrencies.USDC, Networks.ETHEREUM)}
												>
													Transfer
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={usdcethImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													USDC
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													BASE
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.balances.balanceUSDCBASE).toFixed(
														getDecimalsByCrypto(CryptoCurrencies.USDC)
													)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateUSDC).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateUSDC * balances.balances.balanceUSDCBASE).toFixed(
														4
													)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionDepositButton(CryptoCurrencies.USDC, Networks.BASE)}
												>
													Deposit
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionWithdrawalButton(CryptoCurrencies.USDC, Networks.BASE)}
												>
													Withdraw
												</Button>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionTransferButton(CryptoCurrencies.USDC, Networks.BASE)}
												>
													Transfer
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow className={classes.odd}>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={dogeImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													DOGE
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													DOGECOIN
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.balances.balanceDOGE).toFixed(getDecimalsByCrypto(CryptoCurrencies.DOGE))}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateDOGE).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateDOGE * balances.balances.balanceDOGE).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionDepositButton(CryptoCurrencies.DOGE, Networks.DOGECOIN)}
												>
													Deposit
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionWithdrawalButton(CryptoCurrencies.DOGE, Networks.DOGECOIN)}
												>
													Withdraw
												</Button>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionTransferButton(CryptoCurrencies.DOGE, Networks.DOGECOIN)}
												>
													Transfer
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={xrpImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													XRP
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													RIPPLE
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.balances.balanceXRP).toFixed(getDecimalsByCrypto(CryptoCurrencies.XRP))}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateXRP).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateXRP * balances.balances.balanceXRP).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionDepositButton(CryptoCurrencies.XRP, Networks.RIPPLE)}
												>
													Deposit
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionWithdrawalButton(CryptoCurrencies.XRP, Networks.RIPPLE)}
												>
													Withdraw
												</Button>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionTransferButton(CryptoCurrencies.XRP, Networks.RIPPLE)}
												>
													Transfer
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
										<TableRow className={classes.odd}>
											<TableCell sx={{ padding: 0, margin: 0, textAlign: "center" }}>
												<img src={ltcImage} style={{ width: "24px", height: "24px" }} />
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													LTC
												</Typography>
											</TableCell>
											<TableCell sx={{ padding: 0, margin: 0 }}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													LITECOIN
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.balances.balanceLITECOIN).toFixed(getDecimalsByCrypto(CryptoCurrencies.LTC))}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateLTC).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellAmount}>
												<Typography component="h2" variant="subtitle2" gutterBottom>
													{parseFloat(balances.exchangeRate.exchangeRateLTC * balances.balances.balanceLITECOIN).toFixed(4)}
												</Typography>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionDepositButton(CryptoCurrencies.LTC, Networks.LITECOIN)}
												>
													Deposit
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionWithdrawalButton(CryptoCurrencies.LTC, Networks.LITECOIN)}
												>
													Withdraw
												</Button>
											</TableCell>
											{/*<TableCell sx={styleCellButton}>
												<Button
													variant="extended"
													sx={styleButton}
													onClick={() => actionTransferButton(CryptoCurrencies.LTC, Networks.LITECOIN)}
												>
													Transfer
												</Button>
											</TableCell>
											<TableCell sx={styleCellButton}>
											<IconButton color="primary" aria-label="upload picture" component="span" sx={{ border: 0 }}>
												<MoreVertIcon />
											</IconButton>
										</TableCell>*/}
										</TableRow>
									</TableBody>
								</Table>
							</TableContainer>
						</CardContent>
					</Card>
				</>
			);
		}
	} else {
		return (
			<>
				<Grid container sx={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
					<Box>
						<CircularProgress color="primary" size={80} thickness={5} />
					</Box>
				</Grid>
			</>
		);
	}
};

export default AgentBalances;
